import { ScheduleStatus } from '@kai/modules/click-and-collect/modules/homepage-host/models/get-orders-count.response';

export enum LocalStorageKey {
  installationId = 'installation-id',
}

export const SCHEDULE_HISTORY_STATUSES = [ScheduleStatus.CANCELLED, ScheduleStatus.COLLECTED, ScheduleStatus.UNCOLLECTED, ScheduleStatus.REJECTED];
